import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrSetupApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    departments(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrDepartment[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrDepartment[]>>(`${this.baseUrl}/org/departments`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveDepartment(request: HrModels.HrDepartment): Observable<APIResponseWrapper<HrModels.HrDepartment>> {
        return request.departmentId
          ? this.http.put<APIResponseWrapper<HrModels.HrDepartment>>(`${this.baseUrl}/org/departments/${request.departmentId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrDepartment>>(`${this.baseUrl}/org/departments`, request);
      }
    
    jobs(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrJob[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrJob[]>>(`${this.baseUrl}/org/jobs`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveJob(request: HrModels.HrJob): Observable<APIResponseWrapper<HrModels.HrJob>> {
        return request.jobId
          ? this.http.put<APIResponseWrapper<HrModels.HrJob>>(`${this.baseUrl}/org/jobs/${request.jobId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrJob>>(`${this.baseUrl}/org/jobs`, request);
      }
    
    positions(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrPosition[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrPosition[]>>(`${this.baseUrl}/org/positions`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    savePosition(request: HrModels.HrPosition): Observable<APIResponseWrapper<HrModels.HrPosition>> {
        return request.positionId
          ? this.http.put<APIResponseWrapper<HrModels.HrPosition>>(`${this.baseUrl}/org/positions/${request.positionId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrPosition>>(`${this.baseUrl}/org/positions`, request);
      }
    
    workerCategories(activeOnly = true, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrWorkerCategory[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrWorkerCategory[]>>(`${this.baseUrl}/org/worker-categories`, {
          params: this.params({ owningCompanyId, activeOnly })
        });
      }
    
    saveWorkerCategory(request: HrModels.HrWorkerCategory): Observable<APIResponseWrapper<HrModels.HrWorkerCategory>> {
        return request.workerCategoryId
          ? this.http.put<APIResponseWrapper<HrModels.HrWorkerCategory>>(`${this.baseUrl}/org/worker-categories/${request.workerCategoryId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrWorkerCategory>>(`${this.baseUrl}/org/worker-categories`, request);
      }
  };
}

